export default "__VITE_ASSET__CEwr7h4N__"